// Core Modules
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

// External Modules
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// Components
import { UserSettingsComponent } from '@layout/user-settings/user-settings.component';

// Services
import { AuthService } from '@core/services/auth/auth.service';
import { ConfigService } from '@core/services/config/config.service';

// Models
import { HeaderContentModel } from '@shared/models/header-content.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [NgbTooltipModule, RouterLink, UserSettingsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  // Bindings
  public readonly hideSettings = input<boolean>(false);

  // Events
  /** Emitted when the mobile menu button is tapped; the shell opens the nav drawer. */
  public readonly toggleNav = output<void>();

  // Injectors
  public readonly authService = inject(AuthService);
  private readonly configService = inject(ConfigService);

  // Public Members
  public readonly headerContents: HeaderContentModel = this.configService.getContents('header');
  public isMenuCollapsed = false;
}
